import React, { useEffect } from 'react';
import { Card, Tabs } from 'antd';
import { useSearchParams } from 'react-router';
import {
  InboxOutlined,
  ShoppingCartOutlined,
  TransactionOutlined,
} from '@ant-design/icons';
import { InsideStockItemsPage } from './items/InsideStockItemsPage';
import { InsideStockPurchasesPage } from './purchases/InsideStockPurchasesPage';
import { InsideStockTransactionsPage } from './transactions/InsideStockTransactionsPage';

const DEFAULT_TAB = 'items';

const tabContentStyle = {
  height: '100%',
  overflow: 'hidden',
};

// Tab name mapping for better display
const getTabDisplayName = (tabKey: string): string => {
  switch (tabKey) {
    case 'items':
      return 'Items';
    case 'purchases':
      return 'Purchases';
    case 'transactions':
      return 'Transactions';
    default:
      return 'Inside Stock';
  }
};

export const InsideStockPage: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const currentTab = searchParams.get('tab') || DEFAULT_TAB;

  // Update document title when tab changes
  useEffect(() => {
    const tabName = getTabDisplayName(currentTab);
    document.title = `${tabName} - Inside Stock Management`;
  }, [currentTab]);

  const handleTabChange = (key: string) => {
    setSearchParams({ tab: key });
  };

  const items = [
    {
      key: 'items',
      label: (
        <span>
          <InboxOutlined style={{ marginRight: '8px' }} />
          Items
        </span>
      ),
      children: (
        <div style={tabContentStyle}>
          <InsideStockItemsPage />
        </div>
      ),
    },
    {
      key: 'purchases',
      label: (
        <span>
          <ShoppingCartOutlined style={{ marginRight: '8px' }} />
          Purchases
        </span>
      ),
      children: (
        <div style={tabContentStyle}>
          <InsideStockPurchasesPage />
        </div>
      ),
    },
    {
      key: 'transactions',
      label: (
        <span>
          <TransactionOutlined style={{ marginRight: '8px' }} />
          Transactions
        </span>
      ),
      children: (
        <div style={tabContentStyle}>
          <InsideStockTransactionsPage />
        </div>
      ),
    },
  ];

  return (
    <Card
      style={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        overflow: 'auto',
        border: 'none',
      }}
      styles={{
        body: {
          flex: 1,
          padding: 0,
          display: 'flex',
          flexDirection: 'column',
          overflow: 'auto',
        },
      }}
    >
      <Tabs
        activeKey={currentTab}
        onChange={handleTabChange}
        type="line"
        size="large"
        tabPosition="top"
        items={items}
        style={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
          padding: '0 16px',
        }}
        tabBarStyle={{
          margin: 0,
          flexShrink: 0,
        }}
      />
    </Card>
  );
};
